import styled, { css } from "styled-components";
import { ReactComponent as themeIco } from './themeIco.svg';

export const ThemeContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-weight: 700;
    font-size: 12px;
    line-height: 21px;
    margin-bottom: 38px;
    @media (max-width:${({ theme }) => theme.breakpoint.mobileMax}px) {
        align-items: start;
        margin-top: -20px;
    }
`;

export const ThemeCaption = styled.span`
    color: ${({ theme }) => theme.color.slateGray};
    @media (max-width:${({ theme }) => theme.breakpoint.mobileMax}px) {
        display: none;
    }
`;

export const ThemeButton = styled.button`
    display: flex;
    border: none;
    border-radius: 25px;
    padding: 0;
    min-width: 47px;
    margin-left: 12.47px;
    cursor: pointer;
    background-color: ${({ theme }) => theme.color.lightGrey};
`;

export const StyledThemeIco = styled(themeIco)`
    border-radius: 50%;
    color: ${({ theme }) => theme.color.lightBG};
    background-color: ${({ theme }) => theme.color.slateGray};
    margin: 2.5px;
    transition: 500ms;
    ${({ $darkThememe }) => $darkThememe && css`
        transform: translate(100%);
    `}
`;